import { Context } from '@nuxt/types'
import { siteUserPageUrl } from '~/assets/ts/utils/urls'

export default function ({ $users, $redirectTo }: Context) {
  const user = $users.user
  if (!user) return
  $redirectTo(siteUserPageUrl('settings'))
}
